module.exports = __webpack_public_path__ + "static/media/MF2_0133.b0b33b21.webp";